import { buildInterviewPayload } from 'features/sendouts/common/utils';
import { prepareFormToSubmit } from 'UI/utils/forms';

import { OTHER_INTERVIEWER_FORM_FIELDS_MAP } from '../../shared';

export const buildCreateSendoutInterviewPayload = (formData = {}) => {
  const otherInterviewerPayload = prepareFormToSubmit(formData, OTHER_INTERVIEWER_FORM_FIELDS_MAP);
  const { cc_emails: ccs, email, full_name: fullName } = otherInterviewerPayload;

  return {
    interview: {
      ...buildInterviewPayload(formData),
      ccs,
      otherInterviewer: {
        email,
        full_name: fullName
      }
    }
  };
};
